export default __webpack_public_path__ + "static/media/43.27a9cbf2.png";